const projects = [
  {
    name: "Potfolio site for client ",
    url: "https://alahadexports.in/",
    img: require("../images/alahad.png"),
    tags: [
      { name: "html/css" },
      { name: "javascript" },
    ],
    description : "Paid Portfolio website for Client using HTML5, CSS3, JavaScript, Bootstrap, PHP and MYSQL with co-Developer ",
  },
  {
    name: "Chat app ",
    url: "https://madhubabuakkishetty.github.io/chatapp/",
    img: require("../images/chatapp.png"),
    tags: [
      { name: "html/css" },
      { name: "react" },
      { name: "material UI" },
      { name: "Firebase" },
      { name: "Chat App" },
    ],
    description : " Real time Chat app build on HTML5, CSS3, JavaScript, React, Material-UI and firebase with google authenticating.  ",
  },
  {
    name: "Weather app ",
    url: "https://madhubabuakkishetty.github.io/weather/",
    img: require("../images/weatherImg.png"),
    tags: [
      { name: "html/css" },
      { name: "react" },
      { name: "material UI" },
      { name: "weather App" },
    ],
    description : " The Weather app project built on HTML, CSS, JavaScript, React, Material UI, and a weather API is a web application that allows users to check the current weather and forecast for any location around the world. The project uses React and Material UI to create a responsive and visually appealing design that is easy to use on any device. ",
  },
  {
    name: "Calculator App",
    url: "https://madhubabuakkishetty.github.io/calculator/",
    img:   require("../images/calculatorimg.png"),
    tags: [
      { name: "html/css" },
      { name: "react" },
      { name: "material UI" },
      { name: "Calculator App" },
    ],
    description : " The Calculator app project built on HTML, CSS, JavaScript, React, and Material UI is a web application that allows users to perform basic arithmetic calculations using a user-friendly interface. The project uses React and Material UI to create a responsive and visually appealing design that is easy to use on any device. ",
  },
  {
    name: "Dictionary App",
    url: "https://madhubabuakkishetty.github.io/dictionary/",
    img: require("../images/dictionaryImg.png"),
    tags: [
      { name: "html/css" },
      { name: "react" },
      { name: "material UI" },
      { name: "Dictionary App" },
    ],
    description : "The Dictionary app project built on HTML, CSS, JavaScript, React, Material UI, and a dictionary API is a web application that allows users to search for the meanings of words and phrases. The project uses React and Material UI to create a responsive and visually appealing design that is easy to use on any device. ",
  },
];


export default projects;